import { useEffect, useMemo, useCallback, useRef } from "react";
import { useRequestQueueStore } from "stores/requestQueueStore";
import { toast } from "react-toastify";

// const toastId = "project-tree-saving";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type T = any;

export const useBeforeUnload = () => {
  const queue = useRequestQueueStore((state) => state.queue);
  const isProcessing = useMemo<boolean>(() => queue.length > 0, [queue.length]);
  const toastId = useRef<T | null>(null);

  const onProcessing = useCallback(() => {
    if (toastId.current) {
      toast.update(toastId.current, {
        render: "Saving changes...",
        isLoading: true,
        onClose: () => {},
      });
    } else {
      toastId.current = toast.loading("Saving changes...", {
        position: "bottom-right",
      });
    }
  }, []);

  const onComplete = useCallback(() => {
    toast.update(toastId.current, {
      render: "Changes saved",
      type: "success",
      isLoading: false,
      autoClose: 1000,
      hideProgressBar: true,
      onClose: () => {
        toastId.current = null;
      },
    });
  }, []);

  useEffect(() => {
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isProcessing) {
        event.preventDefault();
      }
    };
    if (isProcessing) {
      onProcessing();
    }
    if (!isProcessing) {
      onComplete();
    }

    window.addEventListener("beforeunload", onBeforeUnload);

    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [isProcessing, onComplete, onProcessing]);
};
